import React from "react";

const profiles = ["Node.js", "Python", "iOS"];

const ProfileInput = ({ profile, setProfile }) => {
  return (
    <div>
      <label>
        Profile:
        <select
          value={profile}
          onChange={(e) => setProfile(e.target.value)}
          style={{ marginLeft: "10px", padding: "5px" }}
        >
          {profiles.map((prof) => (
            <option key={prof} value={prof}>
              {prof}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
};

export default ProfileInput;

